module.exports = __webpack_public_path__ + "img/ico-heart-90-x-90.903a647d.svg";